import { useQuery } from '@tanstack/react-query';
import { factoryGetOfficeConsentContentKey } from '../factories/queries';
import { ConsentsService } from '../services';
import type { IOfficeConsentContent } from '../types/OfficeConsentContent';
import type { IGetOfficeConsentContentParameters } from '../types/OfficeConsentContent.parameters';

interface IUseGetOfficeConsentContentOptions {
  params: IGetOfficeConsentContentParameters;
  enabled?: boolean;
}

export const useGetOfficeConsentContent = ({
  params,
  enabled = true,
}: IUseGetOfficeConsentContentOptions) => {
  const { data, error, isError, isLoading, isFetching, refetch } = useQuery<IOfficeConsentContent>({
    queryKey: factoryGetOfficeConsentContentKey(params),
    queryFn: () => ConsentsService.getOfficeConsentContent(params),
    refetchOnWindowFocus: false,
    retry: false,
    enabled,
  });

  return {
    data,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
    refetch,
  };
};
